export default "__VITE_ASSET__DsWnSVjE__"